import React from 'react';
import { SkeletonLoader } from '@hpstellar/core';
import { SummaryTile } from '@hpstellar/core/visId';

import { withError } from '../../../shared/components/error-boundary';
import { Helpers } from '../../../core/src/helpers';
import useProductPrice from '../../../hooks/useProductPrice';
import { getPrimaryImage } from './util';

export const reverseCartItems = Helpers.memoize(
    (cartItems = []) => {
        return cartItems.slice().reverse();
    },
    cartItems => cartItems?.length,
);

//temp component, this should come from GFE eventually
export default withError(({ item }) => {
    const { pNum: sku, name } = item || {};
    const { prices } = useProductPrice([{ sku }], { noFetch: true });
    const priceObj = prices?.[sku];
    const productImage = getPrimaryImage(item, priceObj);
    const imageProps = productImage ? { src: Helpers.getCDNUrl(productImage, undefined, 128), alt: name } : undefined;
    const tileProps = item
        ? {
              sku,
              titleLinkProps: {
                  children: <span dangerouslySetInnerHTML={Helpers.createMarkup(Helpers.decodeHtml(name))} />,
              },
              imageProps,
              deliveryInfo: <SkeletonLoader style={{ height: '32px' }} />,
              QuantitySelectorProps: { readOnly: true },
              PriceBlockProps: {
                  finalPrice: <SkeletonLoader style={{ height: '24px', width: '75px' }} />,
                  msrp: {
                      TooltipProps: {},
                      buttonProps: {
                          children: <SkeletonLoader style={{ height: '14px', width: '34px', marginBottom: '2px' }} />,
                      },
                  },
              },
          }
        : {};
    return item ? (
        <SummaryTile className="cart-item-loader" {...tileProps} />
    ) : (
        <SkeletonLoader className="cart-item-loader" />
    );
});
